import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'product-media',
  name: '商品媒体区',
  icon: '媒',
  group: '商品详情页',
  description: '商品 Banner、图片轮播和视频入口',
  defaultProps: {
    showVideo: true,
    height: 375
  }
}
